<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div class="d-flex flex-row flex-nowrap align-center ma-4">
      <div class="section-title xtium-title mr-3">
        {{ $t('businessProcessesSummmary.businessProcess') }}
      </div>
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        dense
        outlined
        hide-details="true"
        :placeholder="$t('businessProcessesSummmary.search')"
        background-color="surface darken-1"
        @input="onSearchChange"
      ></v-text-field>
    </div>
    <EcsLoading :display="isLoading" />
    <div v-if="!isLoading" class="pa-4 business-process-cards-container">
      <EcsBusinessProcessSummaryCard
        v-for="businessProcess in filteredBusinessProcesses"
        :key="businessProcess.id"
        :business-process="businessProcess"
        :default-from-email="defaultFromEmail"
        :default-bcc-email="defaultBccEmail"
      />
    </div>
  </div>
</template>

<script>
import EcsLoading from '@/components/ecs-spinner/EcsLoading';
import EcsBusinessProcessSummaryCard from '@/components/ecs-summary-view/EcsBusinessProcessSummaryCard';
import debounce from 'lodash/debounce';
export default {
  name: 'EcsBusinessProcessSummary',
  components: { EcsBusinessProcessSummaryCard, EcsLoading },
  props: {
    businessProcesses: {
      type: Array,
      required: true
    },
    defaultFromEmail: {
      type: String,
      required: true
    },
    defaultBccEmail: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      businessProcessFilter: ''
    };
  },
  computed: {
    filteredBusinessProcesses() {
      if (this.businessProcessFilter && this.businessProcessFilter.length > 0) {
        return this.businessProcesses.filter(bp => {
          return (
            bp.name.toUpperCase().includes(this.businessProcessFilter.toUpperCase()) ||
            bp.endPoint === this.businessProcessFilter
          );
        });
      }
      return this.businessProcesses;
    }
  },
  methods: {
    onSearchChange: debounce(function(value) {
      this.businessProcessFilter = value;
    }, 250)
  }
};
</script>

<style scoped>
.section-title {
  color: var(--v-primary-base);
  text-transform: uppercase;
}
.business-process-cards-container {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 2rem;
  overflow: auto;
}
</style>
